import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,

  IconButton,
  InputLabel,
  TextField,
} from "@mui/material";
import React from "react";
import { FormHelperText } from "@material-ui/core";
import MDButton from "../../../components/MDButton/index";
import Grid from "@mui/material/Grid";
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import Checkbox from "@mui/material/Checkbox";
import { useForm } from "react-hook-form";
import MDInput from "../../../components/MDInput";
import { DocumentTypeDialogValidation } from "util/validations/commonValidations";
import SelectDropDown from "./../../../examples/DropDown/index";
import { useDispatch } from "react-redux";
import { addDocumentType } from "../Redux/actionCreator";
import { toast } from "react-toastify";
import SelectDropDownNew from "examples/DropDownNew";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const DocumentTypeDialog = ({ handleDialogClose }) => {
 
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(DocumentTypeDialogValidation),
  });
  const selectOptions = [
    {
      key: "Organization",
      value: "Organization",
    },
    {
      key: "SuperAdmin",
      value: "Super_Admin",
    },
    {
      key: "Applicant",
      value: "Applicant",
    },
  ];

  //Icon Location
  const iconLocationOptions = [
    {
      key: "AWS_S3",
      value: "AWS_S3",
    },
    {
      key: "LOCAL",
      value: "LOCAL",
    },
    {
      key: "SELF_HOSTED",
      value: "SELF_HOSTED",
    },
    {
      key: "CLOUDINARY",
      value: "CLOUDINARY",
    },
  ];
  const [openDialog, setOpenDialog] = useState(false);
  const handleOpenDialog = (event) => setOpenDialog(event.currentTarget);
  const handleCloseDialog = () => setOpenDialog(false);
  const[iconLocation,setIconLocation]=useState();
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    const payload={
      name:data?.name,
      icon:{
        location:iconLocation
      }
    }
    
      dispatch(addDocumentType(payload));
      handleDialogClose();
    
   
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <InputLabel fullWidth className="input-labels">
              Name
            </InputLabel>
          </Grid>

          <Grid item xs={8}>
            <MDInput
              placeholder=""
              sx={{ width: "100%", marginTop: "0.4rem" }}
              inputProps={{
                style: { fontSize: 15, fontWeight: "bold" },
              }}
              {...register("name")}
              error={errors?.name?.message}
              helperText={errors?.name?.message}
            />
          </Grid>
          <Grid item xs={4}>
            <InputLabel fullWidth className="input-labels">
              Icon Location
            </InputLabel>
          </Grid>
          <Grid item xs={8}>
            <SelectDropDownNew
              control={control}
              name={"icon.location"}
             
              options={iconLocationOptions}
              getValues={getValues}
              placeholder="Select"
              customOnChange={(e) => {
                if(errors?.iconLocation?.message)
                errors.iconLocation.message="";
                setIconLocation(e.target.value);
                setValue("iconLocation", e.target.value)}}
            />
            <FormHelperText>{errors?.iconLocation?.message}</FormHelperText>
          </Grid>
        </Grid>

        <MDButton
          variant="contained"
          color="info"
          type="submit"
          sx={{ marginTop: "1.5rem" }}
        >
          create
        </MDButton>
        {/* <MDButton variant="text" color="info" onClick={handleCloseDialog}>
                cancel
              </MDButton> */}
      </form>
    </div>
  );
};

export default DocumentTypeDialog;